import { TileAnimationFrames } from "./TileAnimationFrames";
import { TILES } from "../helpers/tiles";

const WATER_ANIMATION_SPEED = 60;
const WATER_SEQUENCE = [TILES.WATER1, TILES.WATER2];
const FIRE_SEQUENCE = [TILES.FIRE1, TILES.FIRE2, TILES.FIRE3];
const TELEPORT_SEQUENCE = [
  TILES.TELEPORT1,
  TILES.TELEPORT2,
  TILES.TELEPORT3,
  TILES.TELEPORT4,
];

export class AnimatedTiles {
  constructor() {
    // Create each type of animated tile (Configure frames and speeds here)
    this.waterFrames = new TileAnimationFrames(
      WATER_SEQUENCE,
      WATER_ANIMATION_SPEED
    );
    this.fireFrames = new TileAnimationFrames(FIRE_SEQUENCE);
    this.teleportFrames = new TileAnimationFrames(TELEPORT_SEQUENCE);
  }

  // Public method for progressing in animation
  tick() {
    this.waterFrames.tick();
    this.fireFrames.tick();
    this.teleportFrames.tick();
  }

  // Public getters for knowing which frame is current
  get waterFrame() {
    return this.waterFrames.activeFrame;
  }
  get fireFrame() {
    return this.fireFrames.activeFrame;
  }
  get teleportFrame() {
    return this.teleportFrames.activeFrame;
  }
}
